import PropTypes from 'prop-types';
// @mui
import { Box } from '@mui/material';
// components
import { IconButtonAnimate } from 'components/animate';
import { ReactComponent as ClearIcon } from 'assets/images/svg/clear.svg';

// ----------------------------------------------------------------------

CollapseButton.propTypes = {
  onToggleCollapse: PropTypes.func
};

export default function CollapseButton({ onToggleCollapse }) {
  return (
    <IconButtonAnimate onClick={onToggleCollapse}>
      <Box
        sx={{
          lineHeight: 0,
          fontWeight: 'bold'
        }}
      >
        <ClearIcon
          fill="white"
          height={35}
          width={35} />

      </Box>
    </IconButtonAnimate>
  );
}

// ----------------------------------------------------------------------
